import { createAction, props } from '@ngrx/store'
import { EntityTagsResponse } from './model'
import { DataEntityType } from '@tokeet-frontend/tv3-platform'

export const LoadEntityTags = createAction('[EntityTag] Load EntityTags')
export const LoadEntityTagsComplete = createAction(
  '[EntityTag] Load EntityTags Complete',
  props<{ items: EntityTagsResponse[] }>()
)

export const GetEntityTags = createAction(
  '[EntityTag] get tags',
  props<{ entityType: DataEntityType; entityId: string }>()
)
export const GetEntityTagsComplete = createAction(
  '[EntityTag] get tags Complete',
  props<{ item: EntityTagsResponse }>()
)

export const AddEntityTags = createAction(
  '[EntityTag] Add tags',
  props<{ tags: string[]; entityType: DataEntityType; entityId: string; silent?: boolean }>()
)
export const AddEntityTagsComplete = createAction(
  '[EntityTag] Add tags Complete',
  props<{ item: EntityTagsResponse }>()
)

export const UpdateEntityTags = createAction(
  '[EntityTag] update tags',
  props<{ tags: string[]; entityType: DataEntityType; entityId: string; silent?: boolean }>()
)
export const UpdateEntityTagsComplete = createAction(
  '[EntityTag] update tags Complete',
  props<{ item: EntityTagsResponse }>()
)

export const SetEntityTags = createAction(
  '[EntityTag] set tags',
  props<{ tags: string[]; entityType: DataEntityType; entityId: string; silent?: boolean }>()
)

export const DeleteEntityTags = createAction('[EntityTag] delete tags', props<{ id: string; silent?: boolean }>())
export const DeleteEntityTagsComplete = createAction('[EntityTag] delete tags Complete', props<{ id: string }>())

// TV4-6241: Remove a tag from every entity of the given type for the account.
export const RemoveTagFromAllEntities = createAction(
  '[EntityTag] Remove Tag From All Entities',
  props<{ entityType: DataEntityType; tag: string; silent?: boolean }>()
)
export const RemoveTagFromAllEntitiesComplete = createAction(
  '[EntityTag] Remove Tag From All Entities Complete',
  props<{ entityType: DataEntityType; tag: string }>()
)
